import { c as create_ssr_component, e as escape, v as validate_component, a as add_attribute } from "./ssr.js";
import { S as StdHeading, a as StdParagraph } from "./Button.js";
const CopyCard_svelte_svelte_type_style_lang = "";
const css = {
  code: ".desc.svelte-1cetvpr.svelte-1cetvpr{width:100%;height:min-content;padding:2rem 6rem;border-radius:4rem;background-color:#fff;border:0.3rem solid #f36d21;display:grid;grid-template-columns:1.1fr 1fr;gap:10%}@media(max-width: 1500px){.desc.svelte-1cetvpr.svelte-1cetvpr{display:flex;flex-direction:column}}.desc.svelte-1cetvpr img.svelte-1cetvpr{margin:auto;margin-right:0;object-fit:cover;border-radius:2rem}@media(max-width: 1500px){.desc.svelte-1cetvpr img.svelte-1cetvpr{display:none}}.no-icon.svelte-1cetvpr.svelte-1cetvpr{display:block}.short-gap.svelte-1cetvpr.svelte-1cetvpr{grid-template-columns:5fr 1fr;gap:5%}.blue-border.svelte-1cetvpr.svelte-1cetvpr{border:0.3rem solid #0e76bc}.copy.svelte-1cetvpr.svelte-1cetvpr{padding-top:2rem;padding-bottom:2rem;display:flex;flex-direction:column;gap:2rem}.icon.svelte-1cetvpr.svelte-1cetvpr{margin:auto;margin-right:0;text-align:right}@media(max-width: 1500px){.icon.svelte-1cetvpr.svelte-1cetvpr{margin:auto;text-align:center}}",
  map: null
};
const CopyCard = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { src = "" } = $$props;
  let { imgWidth = 486 } = $$props;
  let { imgHeight = 324 } = $$props;
  let { alt = "" } = $$props;
  let { icon = false } = $$props;
  let { blueBorder = false } = $$props;
  if ($$props.src === void 0 && $$bindings.src && src !== void 0)
    $$bindings.src(src);
  if ($$props.imgWidth === void 0 && $$bindings.imgWidth && imgWidth !== void 0)
    $$bindings.imgWidth(imgWidth);
  if ($$props.imgHeight === void 0 && $$bindings.imgHeight && imgHeight !== void 0)
    $$bindings.imgHeight(imgHeight);
  if ($$props.alt === void 0 && $$bindings.alt && alt !== void 0)
    $$bindings.alt(alt);
  if ($$props.icon === void 0 && $$bindings.icon && icon !== void 0)
    $$bindings.icon(icon);
  if ($$props.blueBorder === void 0 && $$bindings.blueBorder && blueBorder !== void 0)
    $$bindings.blueBorder(blueBorder);
  $$result.css.add(css);
  return `<div class="${"desc " + escape(blueBorder ? "blue-border" : "", true) + " " + escape(src ? "" : "short-gap", true) + " " + escape(icon || src ? "" : "no-icon", true) + " svelte-1cetvpr"}"><div class="copy svelte-1cetvpr">${validate_component(StdHeading, "StdHeading").$$render($$result, {}, {}, {
    default: () => {
      return `${slots.heading ? slots.heading({}) : ``}`;
    }
  })} <div class="text">${validate_component(StdParagraph, "StdParagraph").$$render($$result, { color: "black" }, {}, {
    default: () => {
      return `${slots.text ? slots.text({}) : ``}`;
    }
  })}</div></div> ${src ? `<img${add_attribute("src", src, 0)}${add_attribute("alt", alt, 0)} style="${"width: " + escape(imgWidth, true) + "px; height: " + escape(imgHeight, true) + "px"}" class="svelte-1cetvpr">` : ``} ${icon ? `<div class="icon svelte-1cetvpr">${slots.icon ? slots.icon({}) : ``}</div>` : ``} </div>`;
});
export {
  CopyCard as C
};
